module.exports = __webpack_public_path__ + "static/media/RR-AR-office.20c35b02.gif";